import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/site";
import { TiltCard } from "@/components/site/TiltCard";

const stats = [
  { value: "10+", label: "Years in the field" },
  { value: "50+", label: "Systems documented" },
  { value: "100%", label: "Client-first delivery" },
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section ref={ref} id="about" data-testid="about-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-16 border-t border-gray-200 bg-[#F3F4F6] overflow-hidden">
      <div className="mx-auto max-w-[1400px] grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="md:col-span-4"
        >
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-gray-500 mb-4">Why Rae Cloud</p>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-[#0A0A0A] mb-6 leading-none">
            Engineering
            <br />
            you can read.
          </h2>
          <p className="text-base leading-relaxed text-[#52525B]">
            We sit at the intersection of deep technical strategy and plain-language
            communication. That combination means your team gets not only the right
            architecture, but the documentation to run and grow it with confidence.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {stats.map((st) => (
              <div key={st.label} data-testid={`about-stat-${st.value}`}>
                <p className="font-heading text-3xl font-black text-[#0047AB]">{st.value}</p>
                <p className="text-xs text-[#52525B] mt-1 leading-snug">{st.label}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="md:col-span-8 md:mt-8"
        >
          <TiltCard max={5} className="relative overflow-hidden border border-gray-300 shadow-2xl shadow-gray-400/40">
            <motion.img
              src={IMAGES.about}
              alt="Modern office architecture"
              style={{ y: imgY, scale: 1.12 }}
              className="w-full h-[360px] md:h-[520px] object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
            />
          </TiltCard>
        </motion.div>
      </div>
    </section>
  );
};
